import React from 'react';
import { Box, Paper, Skeleton } from '@mui/material';

const PaymentCancelSkeleton: React.FC = () => (
  <Box sx={{ 
    minHeight: '100vh', 
    width: '100vw', 
    background: 'linear-gradient(135deg, #f5f5f5 0%, #ffebee 100%)', 
    py: 4 
  }}>
    <Box maxWidth="sm" sx={{ mx: 'auto', pb: { xs: 10, sm: 4 } }}>
      {/* Cancel Icon and Header Skeleton */}
      <Box sx={{ 
        mt: 4, 
        mb: 3, 
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2
      }}>
        <Skeleton variant="circular" width={80} height={80} />
        <Skeleton variant="text" width="50%" height={40} />
        <Skeleton variant="text" width="70%" height={24} />
      </Box>

      {/* Error/Info Card Skeleton */}
      <Paper sx={{ 
        p: 3, 
        mb: 3, 
        borderRadius: 3, 
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        mr: 3,
        ml: 3
      }}>
        <Skeleton variant="text" width="40%" height={28} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="80%" height={20} />
      </Paper>

      {/* Action Buttons Skeleton */}
      <Box sx={{ mr: 3, ml: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Skeleton variant="rounded" width="100%" height={48} sx={{ borderRadius: 2 }} />
        <Skeleton variant="rounded" width="100%" height={48} sx={{ borderRadius: 2 }} />
      </Box>
    </Box>
  </Box>
);

export default PaymentCancelSkeleton; 